var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5581_7844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 7.83317V4.1665C12.5003 2.78579 11.381 1.6665 10.0003 1.6665C9.01898 1.6665 8.1697 2.23194 7.7605 3.05478M10.0003 15.8332V18.3332M10.0003 15.8332C6.77866 15.8332 4.16699 13.2215 4.16699 9.99984V8.33317M10.0003 15.8332C13.222 15.8332 15.8337 13.2215 15.8337 9.99984V8.33317M6.66699 18.3332H13.3337M1.66699 1.6665L18.3337 18.3332M10.0003 12.4998C8.61961 12.4998 7.50033 11.3805 7.50033 9.99984V7.49984L11.7692 11.7665C11.3167 12.2196 10.6912 12.4998 10.0003 12.4998Z",
    stroke: "#D2D6DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5581_7844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphone-off.f59208e1f2c99f18cc5536d4ff55fd5e.svg";
export { ForwardRef as ReactComponent };